export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\"><circle\n        cx=\"6\"\n        cy=\"6\"\n        r=\"2.5\"\n    /></svg>\n"